import React from "react";
import { chakra, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import styles from "./Styles.module.css";
import tanjiro from "assets/tanjiro.png";

import { faq_url, server_url, invite_url } from "../../config/link.json"

export default function Footer() {
  const language = localStorage.getItem("language");

  const newLanguage = require(`language/${language}.json`);

  return (
    <>
      <chakra.div className={styles.header}>
        &copy; Scary Dev's 2019 - 2023
      </chakra.div>

      <chakra.div className={styles.body}>
        <Image
          src={tanjiro}
          alt="logo bot"
          width="75px"
          borderRadius="37.5px"
          boxShadow="2px 2px 2px 2px rgba(0,0,0,0.2)"
          className={styles.image}
        />

        <chakra.ul>
          <chakra.li>
            <chakra.a href={server_url}>
              {newLanguage.footer.serverSupport}
            </chakra.a>
          </chakra.li>
          <chakra.li>
            <Link to="/guidelines">{newLanguage.footer.guideline}</Link>
          </chakra.li>
          <chakra.li>
            <chakra.a href={faq_url}>FAQ</chakra.a>
          </chakra.li>
          <chakra.li>
            <chakra.a href={invite_url}>
              {newLanguage.footer.invite}
            </chakra.a>
          </chakra.li>
        </chakra.ul>
      </chakra.div>
    </>
  );
}
